// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('base.currencies', {
        url: '/currencies?searchTerm',
        views: {
            'baseList@base': {
                templateUrl: 'main/base/currencies/currencies.tpl.html',
                controller: 'CurrenciesController as vm'
            }
        },
        resolve: {
            currencies: currenciesResolver,
            searchTerm: searchTermesolver
        }
    });
}


// @ngInject
function currenciesResolver(CurrenciesApiService, $stateParams) {
    return CurrenciesApiService.getAll($stateParams.searchTerm);
}

// @ngInject
function searchTermesolver($stateParams) {
    return $stateParams.searchTerm;
}
// @ngInject
function CurrenciesController($rootScope, $state, currencies, $scope, CurrenciesApiService, loadSpinnerService, searchTerm) {
    var vm = this;
    vm.searchTerm = (searchTerm) ? searchTerm : '';
    vm.currencies = currencies;
    vm.selectedCurrencyId = 0;


    // functions
    vm.searchTermChanged = searchTermChanged;

    activate();

    function activate() {
        $rootScope.$on('Currency.Changed', function (event, response) {
            loadCurrencies();
        });
    }
    function searchTermChanged() {
        loadCurrencies();
    }

    function loadCurrencies() {
        loadSpinnerService.start('mainSpinner');
        CurrenciesApiService.getAll(vm.searchTerm).then(function (response) {
            vm.currencies = response;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner', { force: true });
        });
    }

}

angular
    .module('base.currencies', ['currencies.api','currencies.currency'])
    .config(stateConfig)
    .controller('CurrenciesController', CurrenciesController);
